module.exports = __webpack_public_path__ + "static/sport/boxtoprightside.3f4ee38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/boxtoprightside.png
// module id = 3Ilc
// module chunks = 0